import React, { Component } from 'react'

export default class License extends Component {
    render() {
        return (
        <section className="section">
            <section className="container">
                <section className="content">
                <h3>License</h3>
                <hr></hr>
                <p>The Carbon Intensity API is licensed under the terms of the CC BY 4.0. The terms of which, can be viewed <a href="https://creativecommons.org/licenses/by/4.0/">here</a>.</p>
                </section>
            </section>
        </section>
        )
    }
}
